import React from "react";
import "./WordCloud.scss";
import { Colors } from "../../constants"
import { scaleOrdinal } from "d3"

interface Props {
  words: string[];
  color: string;
}

const colorRange: string[] = Object.values(Colors)
const colorScale = scaleOrdinal().range(Object.values(Colors))

function WordCloud ({ words } : Props) {
  return (
    <div className="WordCloud">
      {words.sort().map((d, i) => (
        <div className="parent" key={i} >
          <span className={`list ${colorScale(`${i}`)}`} key={`${i}_word`}>
            {d}
          </span>
        </div>
      ))}
    </div>
  );
}

export default WordCloud;
